import IMask from 'imask';

export default class Callback {
    constructor() {
        this.state = 'fill';
        this.bind();
    }

    popupTemplate() {
        return `
            <div class="modal fade simple-modal callback-modal" id="callback-modal" tabindex="-1" role="dialog"  aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">

                        <div class="modal-body">

                            <button type="button" class="close simple-modal__close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>

                            <div class="simple-modal__title">Обратный звонок</div>
                            <div class="simple-modal__subtitle">
                                Оставьте свои данные и наш менеджер свяжется с вами в течение пары минут
                            </div>

                            <form class="callback-modal__form">
                                <div class="callback-modal__form-body">
                                    <input type="hidden" name="_key" value="qp37rp5tOgDQq" />
                                    <div class="form-group">
                                        <input type="text"
                                            class="callback-modal__input callback-modal__input--name lb-input"
                                            name="name"
                                            placeholder="Ваше имя"
                                            required
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input type="tel"
                                            class="callback-modal__input callback-modal__input--phone lb-input"
                                            name="phone"
                                            placeholder="+7 (900) 000-00-00"
                                            required
                                        />
                                    </div>
                                    <input type="hidden" name="recaptcha_response"> 
                                    <div class="callback-modal__success hidden">Спасибо, мы скоро с вами свяжемся</div>
                                </div>

                                <div class="callback-modal__btn-block">
                                    <button type="submit" class="button-icon callback-modal__submit">
                                        <span class="button-icon__left">
                                            <img class="button-icon__icon" src="${app.assetPath}/img/icons/smartphone-white.svg" alt="" />
                                        </span>
                                        <span class="button-icon__right">Позвоните мне</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
`;
    }

    bind() {
        $('.header-middle__callback-link, .footer__callback').on('click', this.onTriggerClick.bind(this));
        //this.$popup.on('hidden.bs.modal', this.onClose.bind(this));
    }

    bindLazy() {
        this.$popup.find('.callback-modal__form').on('submit', this.onSubmit.bind(this));

        const phoneInput = this.$popup.find('input[name="phone"]').get(0);
        const phoneMask = new IMask(phoneInput, {
            mask: "+{7}(000)000-00-00",
        });
    }

    onTriggerClick(e) {
        e.preventDefault();
        this.show();
    }

    show() {
        if (!this.$popup) {
            // Because of empty #text-node
            this.$popup = $(this.popupTemplate()).eq(0);
            console.log(this.$popup);
            $('body').append(this.$popup);
            this.bindLazy();
        }

        this.setState('fill');
        this.$popup.modal('show');
    }

    setState(state) {
        switch (state) {
            case 'sent':
                console.log(state);
                this.$popup.find('.callback-modal__success').removeClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__left').addClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__right').text('Закрыть');
                this.state = 'sent';

                break;

            case 'fill':
                this.$popup.find('.callback-modal__success').addClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__left').addClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__right').text('Позвоните мне');
                this.$popup.find('form').get(0).reset();
                this.state = 'fill';
                break;
        }
    }

    onSubmit(e) {
        e.preventDefault();

        switch (this.state) {
            case 'sent':
                this.$popup.modal('hide');

                break;

            case 'fill':
            default:
                const name = this.$popup.find('input[name="name"]').val();
                const phone = this.$popup.find('input[name="phone"]').val();

                if (name == '' || (phone == '' && email == '')) {
                    alert('Заполните поля');
                    return;
                }

                const self = this;

                grecaptcha.ready(function () {
                    grecaptcha.execute(app.captchaKey, { action: 'contact' }).then(function (token) {
                        $.ajax({
                            url: '/local/public/callback.php',
                            dataType: 'json',
                            method: 'post',
                            data: {
                                captcha: token,
                                name,
                                phone,
                                ajax: 'Y',
                                formId: 'callback',
                                _protect: self.$popup.find('input[name="_key"]').val().substr(3),
                                sessid: app.sessid
                            }
                        }).done((response) => {
                            if (response.status == 'error') {
                                let errors = '';

                                if (response.error) {
                                    errors = response.error;
                                } else {
                                    for (var i = 0; i < response.errors.length; i++) {
                                        errors += response.errors[i].text + '\n';
                                    }
                                }

                                alert(errors);
                                return;
                            }

                            self.setState('sent');
                        });
                    });
                });

                break;
        }
    }
}